<template>
    <div class="col-xs-12 text-center panel-heading">
        <h1 v-if="event"><strong>{{ event.name }}</strong></h1>
        <h2 v-if="event">{{ event.dateStr }}</h2>
        <div class="row actionBoxes">
            <div class="hidden-xs col-md-1"></div>
            <div class="col-xs-12 col-md-10">
                <div class="matchHeight col-md-4 menuButton" v-if="!$store.state.isTablet">
                    <router-link :to="'/events/' + event_id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_settings"></use></svg>
							</span>
                        <span class="linkText">
								<div class="linkTxtHeader">{{ $t('editEvent') }}</div>
							</span>
                        <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                    </router-link>
                </div>

                <div class="matchHeight col-md-4 menuButton" v-if="!$store.state.isTablet">
                    <router-link :to="'/preset/' + event_id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_remainder"></use></svg>
							</span>
                        <span class="linkText">
								<div class="linkTxtHeader">{{ $t('hallPreset') }}</div>
							</span>
                        <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                    </router-link>
                </div>

                <div class="matchHeight col-md-4 menuButton" v-if="!$store.state.isTablet">
                    <router-link :to="'/guests/' + event_id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_users"><use xlink:href="#i_users"></use></svg>
							</span>
                        <span class="linkText">
								<div class="linkTxtHeader">{{ $t('guests') }}</div>
							</span>
                        <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                    </router-link>
                </div>


                <div class="matchHeight col-md-4 menuButton">
                    <router-link :to="'/seating/' + event_id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_seating"></use></svg>
							</span>
                        <span class="linkText">
								<div class="linkTxtHeader">{{ $t('guestsSitting') }}</div>
							</span>
                        <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                    </router-link>
                </div>

                <div class="matchHeight col-md-4 menuButton"  v-if="!$store.state.isTablet">
                    <router-link :to="'/screen/' + event_id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_template"></use></svg>
							</span>
                        <span class="linkText">
								<div class="linkTxtHeader">{{ $t('screenSettings') }}</div>
							</span>
                        <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                    </router-link>
                </div>

                <div class="matchHeight col-md-4 menuButton" v-if="$store.state.user.type.id !== 3 && !$store.state.isTablet">
                    <a href="#" class="innerBox" @click.prevent="openReportsModal">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_download"></use></svg>
							</span>
                        <span class="linkText">
								<div class="linkTxtHeader">{{ $t('menu_reports') }}</div>
							</span>
                        <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                    </a>
                </div>

                <div class="matchHeight col-md-4 menuButton">
                    <router-link :to="'/tables/' + event_id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_myplace"></use></svg>
							</span>
                        <span class="linkText">
								<div class="linkTxtHeader">{{ $t('tablesStatus') }}</div>
							</span>
                        <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                    </router-link>
                </div>

                <div class="matchHeight col-md-4 menuButton">
                    <router-link :to="'/arrival/' + event_id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_info"></use></svg>
							</span>
                        <span class="linkText">
								<div class="linkTxtHeader">{{ $t('arrivalStatus') }}</div>
							</span>
                        <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                    </router-link>
                </div>

            </div>
            <div class="hidden-xs col-md-1"></div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "EventMenu",
        props:['event_id'],
        data(){
            return{
                event:null,
            }
        },
        mounted(){
            this.$store.dispatch('getEvent',this.event_id)
                                    .then(response =>{
                                        //success
                                        this.event = response.data;
                                    })
                                    .catch(err => {
                                        //err
                                        this.$router.push('/notFound');
                                    })
        },
        methods:{
            openReportsModal(){
                this.$store.state.selectedEventID = this.event_id
                $("#modal-reports").iziModal({
                    autoOpen: 1,
                });
            }
        }
    }
</script>

<style scoped>
    .menuButton{
        margin-top:20px
    }
    .innerBox{
        padding:0
    }


    .pieWrapper .pieInnerWrapper{
        width:50%;
        float: right;
    }

    .pieWrapper #pie-svg{
        width:50%;
        float: right;
    }

    [data-pie-id] > *:nth-child(7n+1), [data-bar-id] > *:nth-child(7n+1), [data-line-id] > *:nth-child(7n+1) {
        color: #293b5a; }
    [data-pie-id] > *:nth-child(7n+2), [data-bar-id] > *:nth-child(7n+2), [data-line-id] > *:nth-child(7n+2) {
        color: #465a7f; }
    [data-pie-id] > *:nth-child(7n+3), [data-bar-id] > *:nth-child(7n+3), [data-line-id] > *:nth-child(7n+3) {
        color: #5e769f; }
    [data-pie-id] > *:nth-child(7n+4), [data-bar-id] > *:nth-child(7n+4), [data-line-id] > *:nth-child(7n+4) {
        color: #7792bf; }



    #pie, #donut, #bar {
        max-height: 450px; }


    svg {
        width: 100%;
        height: auto;
    }


    ul[data-pie-id] {
        list-style: none;
    }
    .pieWrapper ul li{
        font-size:1.118rem;
    }
    .pieWrapper ul li + li{
        margin-top:10px;
    }
    .pieWrapper ul li span{
        color:#2e2e2e;
    }
    .pieWrapper ul li span span{
        font-weight: 700;
        font-style: italic;
    }
    .pieWrapper ul li:before{
        content: "";
        width:17px;
        height:17px;
        border-radius: 50%;
        display:inline-block;
        margin-top:2px;
        margin-left:15px;

    }
    .pieWrapper .pieInnerWrapper{
        padding:0 30px;
    }
    .pieWrapper .pieInnerWrapper h2{

        margin:20px 0px;

    }
    .pieWrapper ul li.notResponded:before{background:#5e769f;}
    .pieWrapper ul li.respondedPositive:before{background:#465a7f;}
    .pieWrapper ul li.respondedMaybe:before{background:#7792bf;}
    .pieWrapper ul li.respondedNegative:before{background:#293b5a;}

    .pieWrapper ul li.notResponded span .status{color:#5e769f;}
    .pieWrapper ul li.respondedPositive span .status{color:#465a7f;}
    .pieWrapper ul li.respondedMaybe span .status{color:#7792bf;}
    .pieWrapper ul li.respondedNegative span .status{color:#293b5a;}
    .innerMainContent {
        padding: 55px 45px;
        float: right;
        width: 100%;
    }
    .eventInfoWrapper {
        padding: 20px;
        float: right;
        width: 100%;
    }

    .imgWrap{
        width: 50%;
        float: right;
    }
    .imgWrap img{
        width:100%;
    }

    .actionBoxes .innerBox{
        width:100%;
        display:block;
        padding: 30px;
        background: #fff;
        transition: background .25s ease-in-out;
        -moz-transition: background .25s ease-in-out;
        -webkit-transition: background .25s ease-in-out;

    }
    .actionBoxes .innerBox:hover,
    .actionBoxes .innerBox:focus{
        text-decoration: none;
        transition: background .25s ease-in-out;
        -moz-transition: background .25s ease-in-out;
        -webkit-transition: background .25s ease-in-out;
        background: -moz-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41,59,90,1)), color-stop(100%, rgba(123,150,196,1))); /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* ie10+ */
        background: linear-gradient(90deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* w3c */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4',GradientType=1 ); /* ie6-9 */
    }
    .actionBoxes .innerBox + .innerBox{
        margin-top:45px;
    }
    .actionBoxes .innerBox .svgWrap{
        display:block;
        margin: 0 auto;
        vertical-align:middle;
        width:83px;
        height:83px;
        border-radius:50%;
        border:1px solid #80ebdf;
        background: #fff;
        text-align: center;
        margin-bottom:20px;
    }
    .actionBoxes .innerBox .svgWrap .i_users{
        width:39px;
        height:29px;
        fill:#293b5a;
        margin-top: 24px;
    }
    .actionBoxes .innerBox .svgWrap .i_template{
        width:19px;
        height:30px;
        fill:#293b5a;
        margin-top: 25px;
    }
    .actionBoxes .innerBox .linkText{
        text-align: center;
    }
    .actionBoxes .innerBox .linkText .linkTxtNum{
        color:#99aed1;
        font-size:2.412rem;
        font-weight:400;
    }
    .actionBoxes .innerBox .linkText .linkTxtHeader{
        color:#293b5a;
        font-size: 1.059rem;
        font-weight:700;
    }
    .actionBoxes .innerBox:hover .linkTxtNum,
    .actionBoxes .innerBox:focus .linkTxtNum,
    .actionBoxes .innerBox:hover .linkTxtHeader,
    .actionBoxes .innerBox:focus .linkTxtHeader{
        color:#fff;
    }
    .actionBoxes .innerBox .i_linkArr{
        display: block;
        vertical-align: middle;
        fill: #7b96c4;
        width: 38px;
        height: 38px;
        margin: 20px auto 0;
    }
    .actionBoxes .innerBox:hover .i_linkArr,
    .actionBoxes .innerBox:focus .i_linkArr{
        fill:#fff;
    }
    .matchHeight .innerBox{
        height:100%;
    }
    .actionBoxes{
        margin-top:30px;
    }
    .infoWrap{
        width:50%;
        float: right;
        text-align: center;
    }
    .infoWrap h1{
        color:#293b5a;
        font-size: 2.353rem;
        font-weight: 700;
    }
    .eventType{
        color:#87a0c9;
        font-weight: 700;
        font-style: italic;
        font-size: 1.529rem;
    }
    .eventDate{
        display: inline-block;
        padding: 15px 20px;
        position: relative;
        margin: 20px 0;
    }
    .eventDate:before,
    .eventDate:after{
        content: "";
        height:1px;
        width: 100%;
        background: #55e4d4;
        position: absolute;
        right:0;
    }
    .eventDate:before{
        bottom:100%;
    }
    .eventDate:after{
        top:100%;
    }
    .eventDate svg{
        width:29px;
        height:29px;
        fill:#293b5a;
        display: inline-block;
        vertical-align: middle;
        margin-left:10px;
    }
    .eventDate span{
        color:#293b5a;
        font-size: 1.353rem;
        display: inline-block;
        vertical-align: middle;

    }
    .eventTimeLeft{
        color:#eb001c;
        font-size: 1.176rem;
    }

</style>